/**
 * Card text is "ID: GHA-C9F1FEB". The profile id search uses the part after a
 * leading "ID:" and a leading "GHA-" or "GHA".
 */
function agentProfileIdSearchFragment (keywords) {
  if (!keywords || typeof keywords !== 'string') {
    return ''
  }

  let value = keywords.trim().replace(/^id:\s*/i, '').trim()
  if (/^gha-/i.test(value)) {
    value = value.replace(/^gha-/i, '')
  } else if (/^gha/i.test(value)) {
    value = value.replace(/^gha/i, '')
  }

  return escapeIlike(value.trim())
}

function escapeIlike (value) {
  return value.replace(/\\/g, '\\\\').replace(/%/g, '\\%').replace(/_/g, '\\_')
}

/**
 * True when the search is a card id or profile id, not a name, email, or phone.
 * "Ghana" stays a name search. A phone number stays a phone search.
 */
function looksLikeProfileId (keywords) {
  if (!keywords || typeof keywords !== 'string') {
    return false
  }
  const trimmed = keywords.trim().replace(/^id:\s*/i, '').trim()
  if (!trimmed) {
    return false
  }
  return hasGhaIdPrefix(trimmed) || isUuid(trimmed) || isHexIdSuffix(trimmed)
}

function hasGhaIdPrefix (value) {
  if (/^gha-/i.test(value)) {
    return true
  }
  if (/^gha\s+/i.test(value)) {
    return true
  }
  return /^gha[0-9a-f]/i.test(value)
}

function isUuid (value) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
}

function isHexIdSuffix (value) {
  if (!/^[0-9a-f]{4,}$/i.test(value)) {
    return false
  }
  return /[a-f]/i.test(value)
}

function agentProfileIdMatch (keywords) {
  if (!looksLikeProfileId(keywords)) {
    return null
  }
  const fragment = agentProfileIdSearchFragment(keywords)
  if (!fragment) {
    return null
  }
  return { id: { ilike: '%' + fragment } }
}

function agentSelectorMatchesQuery (item, queryText) {
  if (!queryText) {
    return true
  }

  const query = String(queryText).toLowerCase()
  const fields = [item && item.fullName, item && item.phone, item && item.email]
  for (let i = 0; i < fields.length; i++) {
    if (String(fields[i] || '').toLowerCase().indexOf(query) !== -1) {
      return true
    }
  }

  const fragment = agentProfileIdSearchFragment(queryText).toLowerCase()
  if (!looksLikeProfileId(queryText) || !fragment) {
    return false
  }

  return String(item && item.id || '').toLowerCase().indexOf(fragment) !== -1
}

module.exports = {
  agentProfileIdSearchFragment,
  looksLikeProfileId,
  agentProfileIdMatch,
  agentSelectorMatchesQuery
}
